import type {UseFormReturn} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import {Textarea} from '@/components/ui/textarea';

import type {TaskActionFormValues} from '../../utils/tasksFormInputs';

type EditTaskCommentFormFieldsProps = {
  form: UseFormReturn<TaskActionFormValues>;
};

function EditTaskCommentFormFields({form}: EditTaskCommentFormFieldsProps) {
  const {t} = useTranslation();

  return (
    <div className="mt-6 flex flex-col gap-3">
      <FormField
        control={form.control}
        name="comment"
        render={({field}) => (
          <FormItem>
            <FormLabel>{t('Comment')}</FormLabel>
            <FormControl>
              <Textarea {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}

export default EditTaskCommentFormFields;
